<div
  *ngFor="let location of areaLocations; index as i; trackBy: areaLocationsTrackBy"
  class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-section form-font-size component-container">
  <div *ngIf="!useDropdownForArea" class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
    <label class="ui-g-5 field-label text-right-align">{{ 'grid-comp.area' | translate }}</label>
    <input
      class="ui-input pInputText"
      pInputText
      size="30"
      [(ngModel)]="location.area"
      name="area{{ i }}"
      #area{{i}}="ngModel"
      [disabled]="isConnectionAddressDisabled()" />
  </div>
  <div *ngIf="useDropdownForArea" class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
    <label class="ui-g-5 field-label text-right-align">{{ 'grid-comp.area' | translate }}</label>
    <p-dropdown
      [options]="areaOptions"
      optionLabel="area"
      dataKey="area"
      [filter]="true"
      placeholder="-Select-"
      (onChange)="selectArea($event.value, i)"
      [disabled]="isConnectionAddressDisabled()"
      [ngModelOptions]="{ standalone: true }"
      [(ngModel)]="location.areaOption"></p-dropdown>
  </div>
  <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
    <label class="ui-g-5 field-label text-right-align">{{ 'grid-comp.field' | translate }}</label>
    <input
      class="ui-input pInputText"
      maxlength="100"
      pInputText
      size="30"
      [(ngModel)]="location.field"
      name="field{{ i }}"
      #field{{i}}="ngModel"
      [disabled]="isConnectionAddressDisabled()" />
  </div>
  <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 form-rows"></div>
  <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
    <label class="ui-g-5 field-label text-right-align">{{ 'grid-comp.field-sector' | translate }}</label>
    <input
      class="ui-input pInputText"
      maxlength="100"
      pInputText
      size="30"
      [(ngModel)]="location.field_sector"
      name="field_sector{{ i }}"
      #field_sector{{i}}="ngModel"
      [disabled]="isConnectionAddressDisabled()" />
  </div>
  <div class="ui-g-2 ui-xl-2 ui-lg-2 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">
    <div
      *ngIf="i > 0 && !isDetailsView"
      (click)="removeLocation(location)"
      class="pi pi-trash pointer-cursor right-aligned"
      [ngClass]="isConnectionAddressDisabled() ? 'disable-section' : ''"></div>
  </div>
</div>
